import { faBuilding, faFolder, faGlobe, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Workspace } from '@workspace/domain/workspace';
import { Link } from 'react-router-dom';
import { usePrimitiveValueListener } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import type { WorkspaceInternalPublicMemberRoleJSON } from 'balus-common';
import { HighlightText } from './HighlightText';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';

type Props = {
  workspace: Workspace;
  searchKeyword?: string;
};

export const WorkspaceItemTitle: React.FC<Props> = ({ workspace, searchKeyword }: Props) => {
  const [internalPublicSetting] = usePrimitiveValueListener<WorkspaceInternalPublicMemberRoleJSON>(
    RTDBPath.Group.internalPublicWorkspacePath(workspace.groupId, workspace.id)
  );

  return (
    <Link to={UserPagePathBuilder.workspacePage(workspace.id)} className="flex items-center justify-start py-1 pr-1">
      <span className="fa-layers fa-fw mr-1 shrink-0 text-brand">
        <FontAwesomeIcon icon={faFolder} />
        <FontAwesomeIcon
          icon={
            workspace.isPersonal
              ? faUser
              : workspace.isPublicSpace
                ? faGlobe
                : internalPublicSetting
                  ? faBuilding
                  : faLock
          }
          inverse
          transform="shrink-8 down-1"
        />
      </span>
      <HighlightText className="min-w-0 truncate" text={workspace.name.toString()} keyword={searchKeyword || ''} />
    </Link>
  );
};
